import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

const UseNotifications = () => {
  const { authFetch } = useAuth();

  const [notificationsOpen, setNotificationsOpen] = useState(false);

  const [notifications, setNotifications] = useState([]);

  const [loadingNotifications, setLoadingNotifications] = useState(false);

  const [confirmDeleteNotifications, setConfirmDeleteNotifications] =
    useState(null);

  const formatRelativeTime = (date) => {
    const created = new Date(date);

    const now = new Date();

    const diffMs = now - created;

    const minutes = Math.floor(diffMs / 60000);

    const hours = Math.floor(diffMs / 3600000);

    const days = Math.floor(diffMs / 86400000);

    if (minutes < 1) {
      return "agora";
    }

    if (minutes < 60) {
      return `há ${minutes} minuto${minutes > 1 ? "s" : ""}`;
    }

    if (hours < 24) {
      return `há ${hours} hora${hours > 1 ? "s" : ""}`;
    }

    if (days === 1) {
      return "ontem";
    }

    if (days < 30) {
      return `há ${days} dia${days > 1 ? "s" : ""}`;
    }

    const months = Math.floor(days / 30);

    if (months < 12) {
      return `há ${months} mês${months > 1 ? "es" : ""}`;
    }

    const years = Math.floor(months / 12);

    return `há ${years} ano${years > 1 ? "s" : ""}`;
  };

  const fetchNotifications = useCallback(async () => {
    try {
      setLoadingNotifications(true);

      const response = await authFetch(`${API_URL}/api/notifications/`);

      const data = await response.json();

      if (!response.ok) {
        throw new Error();
      }

      const formatted = data.resultados.map((item) => ({
        ...item,
        time: formatRelativeTime(item.created_at),
      }));

      setNotifications(formatted);
    } catch {
      setNotifications([]);
    } finally {
      setLoadingNotifications(false);
    }
  }, [authFetch]);

  const handleNotifications = async () => {
    try {
      setNotificationsOpen(true);

      await authFetch(`${API_URL}/api/notifications/viewed/`, {
        method: "PATCH",
        headers: {
          //Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      setNotifications((prev) =>
        prev.map((n) => ({
          ...n,
          viewed: true,
        })),
      );
    } catch (err) {
      console.log(err);
    }
  };

  const removeNotification = async (id) => {
    try {
      await authFetch(`${API_URL}/api/notifications/${id}/`, {
        method: "DELETE",
      });

      setNotifications((prev) => prev.filter((item) => item.id !== id));

      setConfirmDeleteNotifications(null);
    } catch {}
  };

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  useEffect(() => {
    if (notificationsOpen) {
      fetchNotifications();
    }
  }, [notificationsOpen, fetchNotifications]);

  return {
    notificationsOpen,
    setNotificationsOpen,

    notifications,

    loadingNotifications,

    confirmDeleteNotifications,
    setConfirmDeleteNotifications,
    handleNotifications,
    removeNotification,
  };
};

export default UseNotifications;
